export default __webpack_public_path__ + "static/media/1.cdf831ee.svg";